import Vue from 'vue';
import axios from 'axios'
import App from './App.vue';
import store from './store';
import BootstrapVue from 'bootstrap-vue'
import VueGtag from "vue-gtag";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './css/helpers.less'
import './css/theme.less'
import moment from 'moment';
import 'moment/locale/de';
import { formatDate } from './formatDate';

Vue.config.productionTip = false;

// configure axios
const axiosInstance = axios.create();

// make axios instance accessible via this.$axios in component
Vue.prototype.$http = axiosInstance;

Vue.use(BootstrapVue);

Vue.use(VueGtag, {
	config: { id: "G-DSMMQ6V6RW",
		params: {
			anonymize_ip: true
		}
	}
});

// dates in templates: $formatDate(value, format)
moment.locale('de');
Vue.prototype.$formatDate = formatDate;

let vm = new Vue({
	store,
	render: (h) => h(App),
}).$mount('#app');
